import * as React from 'react';
import { useIntl } from 'react-intl';
import { useRecoilState } from 'recoil';
import { isRidePlayerMenuOpenAtom } from '../OnlineMapState';
import useAnalytics from '../../../hooks/useAnalytics';

export default function PlayerControl(): JSX.Element {
  const { trackEvent } = useAnalytics();
  const { formatMessage: f } = useIntl();

  const [isRidePlayerMenuOpen, setIsRidePlayerMenuOpen] = useRecoilState(isRidePlayerMenuOpenAtom);

  const handleOpenRidePlayerMenu = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    event.preventDefault();

    if (isRidePlayerMenuOpen) {
      trackEvent(['Ride player', 'click', 'Close ride player settings menu']);
      setIsRidePlayerMenuOpen(false);
    } else {
      trackEvent(['Ride player', 'click', 'Open ride player settings menu']);
      setIsRidePlayerMenuOpen(true);
    }
  };

  return (
    <a
      onClick={handleOpenRidePlayerMenu}
      title={f({ id: 'map.rideplayer.menu.settings' })}
      data-cy="controls-on-map-ride-player-menu"
      className={`${isRidePlayerMenuOpen ? 'e-button-sq text-primary' : 'e-button-sq'}`}
    >
      <i className="cmd-icons cmd-icon-player-setting" />
    </a>
  );
}
